import axios from 'axios'


const state = {
	query_moodules: [],
	active_module: false
}

const mutations = {

	setModules(state,Reports){

		state.query_moodules = Object.keys(Reports).map((module)=>{

			if(typeof Reports[module] != 'object'){
				return console.error(`[${module}] is not an object`);
			}

			if(!Reports[module].hasOwnProperty('binding')){
				return console.error(`[${module}] Requires 'binding' attribute`);
			}

			if(!Reports[module].hasOwnProperty('query')){
				return console.error(`[${module}] Requires 'query' attribute`);
			}

			if(!Reports[module].hasOwnProperty('config')){
				return console.error(`[${module}] Requires 'config' attribute`);
			}

			return {
				module_name: module,
				module: Reports[module]
			};

		});

	},

	setActiveModule(state,module){
		state.active_module = module
	}

}

const actions = {

}

export default {
	state,
	mutations,
	actions
}